import { IconName } from '@mgmresorts/mgm-ui';

export type MfaEnrollmentFlowType = 'signup' | 'activate' | 'passkey' | 'signin';

export interface MfaEnrollmentFlowConfig {
  message: string;
  iconName: IconName;
  iconColor: string;
  hideEmailEnrollment?: boolean;
  hideSMSEnrollment?: boolean;
  hidePasskeyEnrollment?: boolean;
}

export const MFA_ENROLLMENT_FLOW_CONFIG: Record<MfaEnrollmentFlowType, MfaEnrollmentFlowConfig> = {
  signup: {
    message: 'Your email is verified',
    iconName: 'checkmark-circle',
    iconColor: '#007636',
  },
  passkey: {
    message: 'A passkey has been created',
    iconName: 'checkmark-circle',
    iconColor: '#007636',
    hidePasskeyEnrollment: true,
  },
  activate: {
    message: 'Your details are confirmed',
    iconName: 'checkmark-circle',
    iconColor: '#007636',
  },
  signin: {
    message: 'Enhance your account security',
    iconName: 'shield-plus',
    iconColor: '#00012B',
  },
};
